// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"80d728c0","360":"509f6957","521":"50dedc82","538":"e8caf586","600":"4a56f3cc","666":"514a3711","744":"3997febf","820":"7174bcd2","931":"1b93502c","951":"3612b6e4"}[chunkId] + ".chunk.css";
};